
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top200",
      function () {
        return require("private-next-pages/top200.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top200"])
      });
    }
  